import Portal from 'preact-portal';

export default class SafePortal extends Portal {
    componentWillUnmount() {
        try {
            super.componentWillUnmount();
        } catch (e) {
            if (this.props && this.props.unmountFallback) {
                this.props.unmountFallback();
            }
            console.trace('Error on Portal component unmounting', e);
        }
    }
}
